// src/modules/analytics/pages/AnalyticsPage.tsx
import { Box, Typography, Alert, Stack } from '@mui/material';
import { alpha } from '@mui/material/styles';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import { FiltersBar } from '../components/FiltersBar';
import { KpiCards } from '../components/KpiCards';
import { TokensBarChart } from '../components/TokensBarChart';
import { UsersStatsTable } from '../components/UsersStatsTable';
import { useAnalytics } from '../hooks/use-analytics';
import { useUsersStats } from '../hooks/use-users-stats';
import { USE_NEW_SHELL } from 'core/flags';
import { PageShell } from 'components/AppShell';

export default function AnalyticsPage() {
  const {
    pendingFilters,
    setPendingFilters,
    appliedFilters,
    stats,
    loading,
    error,
    kpi,
    applyFilters,
  } = useAnalytics();

  const usersStats = useUsersStats(appliedFilters);

  const body = (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <FiltersBar
        filters={pendingFilters}
        onChange={setPendingFilters}
        onApply={applyFilters}
        loading={loading}
      />
      {error && <Alert severity="error">{error}</Alert>}
      <KpiCards kpi={kpi} loading={loading} />
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'stretch' }}>
        <Box sx={{ flex: 2, minWidth: 0 }}>
          <TokensBarChart data={stats} loading={loading} />
        </Box>
      </Box>
      <UsersStatsTable state={usersStats} />
    </Box>
  );

  if (USE_NEW_SHELL) {
    return (
      <PageShell
        title="Аналитика LLM"
        subtitle="Статистика использования токенов и производительности"
      >
        {body}
      </PageShell>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Stack
        direction="row"
        spacing={1.5}
        alignItems="center"
        sx={{
          p: 1.5,
          borderRadius: 2,
          background: (t) => t.palette.background.paper,
          border: (t) => `1px solid ${t.palette.divider}`,
          borderLeft: (t) => `3px solid ${t.palette.primary.main}`,
          boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        }}
      >
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: (t) => t.palette.primary.main,
            color: 'white',
            boxShadow: (t) => `0 2px 8px ${alpha(t.palette.primary.main, 0.35)}`,
            flexShrink: 0,
          }}
        >
          <BarChartOutlinedIcon fontSize="small" />
        </Box>
        <Box>
          <Typography sx={{ fontSize: '1.05rem', fontWeight: 700, lineHeight: 1.2 }}>
            Аналитика LLM
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Статистика использования токенов и производительности
          </Typography>
        </Box>
      </Stack>
      {body}
    </Box>
  );
}
